<template>
  <transition name="fade">
    <div class="errorsDisplay" v-if="errors.length">
      <ul class="errorsDisplay__list">
        <li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
      </ul>
      <a
        href="#"
        @click.prevent="close"
        class="errorsDisplay__close"
        >
        <icon name="remove" />
      </a>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState([
      'errors'
    ])
  },
  methods: {
    close () {
      this.$store.commit('removeErrors')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~$scss/globals';

.errorsDisplay {
  position: relative;
  position: fixed;
  left: 20px;
  bottom: 20px;
  width: 600px;
  background: #444;
  padding: 20px;
  color: white;
  z-index: 9999;
  @include breakpoint(max-width $screenSm) {
    width: calc(100% - 40px);
  }
  &__list {
    margin-bottom: 0;
    padding-right: 20px;
  }
  &__close {
    position: absolute;
    right: 10px;
    top: 7px;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Errors.vue